import { render, staticRenderFns } from "./StudioSettingsSocials.vue?vue&type=template&id=55dc06e3&scoped=true"
import script from "./StudioSettingsSocials.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioSettingsSocials.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioSettingsSocials.vue?vue&type=style&index=0&id=55dc06e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc06e3",
  null
  
)

export default component.exports